// API Configuration for Artifi Contract Analyzer

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

export const API_ENDPOINTS = {
  // Document endpoints
  DOCUMENTS: '/documents',
  DOCUMENT_UPLOAD: '/documents/upload',
  DOCUMENT_PROCESS: '/documents/process',
  DOCUMENT_ANALYSIS: '/documents/analysis',
  
  // Term endpoints
  CONTRACT_TERMS: '/contract-terms',
  TERM_INSTANCES: '/term-instances',
  RISK_ANALYSES: '/risk-analyses',
  
  // Analysis endpoints
  ANALYZE_DOCUMENT: '/analyze',
  DOCUMENT_SUMMARY: '/summary',
  
  // Future agent endpoints (placeholder)
  AGENT_CHAT: '/agent/chat',
  AGENT_INSIGHTS: '/agent/insights',
} as const;

export const MONGODB_CONFIG = {
  DATABASE_NAME: process.env.REACT_APP_DATABASE_NAME || 'doc_intel',
  COLLECTIONS: {
    DOCUMENTS: 'documents',
    CONTRACT_TERMS: 'contract_terms',
    TERM_INSTANCES: 'term_instances',
    RISK_ANALYSES: 'risk_analyses',
  },
} as const;

export const REQUEST_TIMEOUT = 30000; // 30 seconds
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const SUPPORTED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'] as const;
